// extracted by mini-css-extract-plugin
module.exports = {"normal":"styles_normal__2r8W0","reload":"styles_reload__2OfUZ"};